import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ChairAltSharpIcon from '@mui/icons-material/ChairAltSharp';
import Collapse from '@mui/material/Collapse';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import GetAppIcon from '@mui/icons-material/GetApp';
import GroupIcon from '@mui/icons-material/Group';
import LayersIcon from '@mui/icons-material/Layers';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import SpeedIcon from '@mui/icons-material/Speed';
import { isAdminSession } from '../auth/session';

function NavigationItem({ icon: Icon, text, to, sx }) {
  const navigate = useNavigate();

  return (
    <ListItemButton onClick={() => navigate(to)} sx={sx}>
      <ListItemIcon>
        <Icon />
      </ListItemIcon>
      <ListItemText primary={text} />
    </ListItemButton>
  );
}

function NavigationGroup({ icon: Icon, text, children }) {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <ListItemButton onClick={() => setOpen((previous) => !previous)}>
        <ListItemIcon>
          <Icon />
        </ListItemIcon>
        <ListItemText primary={text} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </>
  );
}

function MainNavigationItems() {
  const isAdmin = isAdminSession();

  return (
    <>
      <NavigationItem icon={SpaceDashboardIcon} text="Dashboard" to="/dashboard" />
      <NavigationItem icon={PersonAddIcon} text="Crear Paciente" to="/crear-paciente-user" />
      <NavigationItem icon={GroupIcon} text="Pacientes" to="/home" />
      {isAdmin ? <NavigationItem icon={GetAppIcon} text="Generador Excel" to="/generador-excel" /> : null}
      {isAdmin ? <NavigationItem icon={GroupIcon} text="Usuarios" to="/lista-usuarios" /> : null}
      <NavigationItem icon={AssignmentIcon} text="Entrevista" to="/lista-entrevistas" />
      <NavigationItem icon={FitnessCenterIcon} text="Antropometria" to="/lista-antropometria" />
      <NavigationItem icon={SpeedIcon} text="Fuerza Presion" to="/lista-valoracion-funcional" />
      <NavigationItem icon={DirectionsRunIcon} text="SPPB / TUG" to="/lista-capacidad-funcional" />
      <NavigationItem icon={ChairAltSharpIcon} text="5STS / Encoder" to="/lista-encoder" />
      <NavigationGroup icon={LayersIcon} text="Cuestionarios">
        <List component="div" disablePadding>
          <NavigationItem icon={LayersIcon} text="Ventilacion" to="/lista-vent" sx={{ pl: 4 }} />
          <NavigationItem icon={LayersIcon} text="Suelo Pelvico" to="/lista-sp" sx={{ pl: 4 }} />
          <NavigationItem icon={LayersIcon} text="Tesis Torres" to="/lista-tesis" sx={{ pl: 4 }} />
        </List>
      </NavigationGroup>
    </>
  );
}

export const mainNavigationItems = <MainNavigationItems />;
